<div class="breadcrumb bread_custom">
  <div class="breadcrumb-container ml-2 pt-0">
    <ul>
      <li class="breadcrumb-item">
        <a [routerLink]="['']"><i class="fa fa-home" aria-hidden="true" (click)="removeRouteTrack()"></i></a>
      </li>
      <li *ngFor="let breadcrumb of breadcrumbs; trackBy: trackByFn" class="breadcrumb-item">
        <a [routerLink]="[breadcrumb.url, breadcrumb.params]" [textContent]="breadcrumb.label"></a>
      </li>
    </ul>
  </div>
</div>